import { render, staticRenderFns } from "./AttributeDefinitionTemplateTable.global.vue?vue&type=template&id=539d6fcf&lang=pug&"
import script from "./AttributeDefinitionTemplateTable.global.vue?vue&type=script&lang=ts&"
export * from "./AttributeDefinitionTemplateTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports